export class Core {
    public values: Values = new Values();
    public checks: Checks = new Checks();
}

export class Values {
    public create_date: string = ""
    public pat_name: string = ""
    
    public desingr_sum: string = ""
    public genzai_other: string = ""
    public hassei_date: string = ""
    public shokai_date: string = ""
    public kako_other: string = ""
    public keikaku_bed: string = ""
    public keikaku_eiyo: string = ""
    public keikaku_isu: string = ""
    public keikaku_riha: string = ""
    public keikaku_skin: string = ""
    public pat_birthday: string = ""
    public user_name: string = ""
}

export class Checks {
    public c1_bed_ari: boolean = true
    public c1_bed_nashi: boolean = false
    public c1_isu_ari: boolean = true
    public c1_isu_nashi: boolean = false
    public c2_ari: boolean = false
    public c2_nashi: boolean = true
    public c3_ari: boolean = false
    public c3_nashi: boolean = true
    public c4_ari: boolean = false
    public c4_nashi: boolean = true
    public c5_ari: boolean = false
    public c5_nashi: boolean = true
    public c6_ari: boolean = false
    public c6_nashi: boolean = true
    public c7_ari: boolean = false
    public c7_nashi: boolean = true
    public check_female: boolean = false
    public check_male: boolean = false
    public d0: boolean = true
    public d1: boolean = false
    public d2: boolean = false
    public d3: boolean = false
    public d4: boolean = false
    public d5: boolean = false
    public dti: boolean = false
    public du: boolean = false
    public e0: boolean = true
    public e1: boolean = false
    public e3: boolean = false
    public e6: boolean = false
    public g0: boolean = true
    public g1: boolean = false
    public g3: boolean = false
    public g4: boolean = false
    public g5: boolean = false
    public g6: boolean = false
    public genzai_1: boolean = false
    public genzai_2: boolean = false
    public genzai_3: boolean = false
    public genzai_4: boolean = false
    public genzai_5: boolean = false
    public genzai_6: boolean = false
    public genzai_7: boolean = false
    public genzai_ari: boolean = false
    public genzai_nashi: boolean = false
    public i0: boolean = true
    public i1: boolean = false
    public i3: boolean = false
    public i3c: boolean = false
    public i9: boolean = false
    public jiritsu_a1: boolean = false
    public jiritsu_a2: boolean = false
    public jiritsu_b1: boolean = false
    public jiritsu_b2: boolean = false
    public jiritsu_c1: boolean = false
    public jiritsu_c2: boolean = false
    public jiritsu_j1: boolean = true
    public jiritsu_j2: boolean = false
    public kako_1: boolean = false
    public kako_2: boolean = false
    public kako_3: boolean = false
    public kako_4: boolean = false
    public kako_5: boolean = false
    public kako_6: boolean = false
    public kako_7: boolean = false
    public kako_ari: boolean = false
    public kako_nashi: boolean = true
    public n0: boolean = true
    public n3: boolean = false
    public n6: boolean = false
    public r0: boolean = true
    public r12: boolean = false
    public r24: boolean = false
    public r6: boolean = false
    public r9: boolean = false
    public s0: boolean = true
    public s12: boolean = false
    public s15: boolean = false
    public s3: boolean = false
    public s6: boolean = false
    public s8: boolean = false
    public s9: boolean = false
}


export const jokuso_lists_title = [
    "深さ",
    "浸出液",
    "大きさ(cm^2)",
    "炎症・感染",
    "肉芽形成",
    "壊死組織",
    "ポケット(cm^2)",
]
export const jokuso_lists_simple = [
    [
        "d0", "d1", "d2", "D3", "D4", "D5", "DDTI", "DU",
    ], [
        "e0", "e1", "e3", "E6",
    ], [
        "s0", "s3", "s6", "s8", "s9", "s12", "S15",
    ], [
        "i0", "i1", "I3C", "I3", "I9",
    ], [
        "g0", "g1", "g3", "G4", "G5", "G6",
    ], [
        "n0", "N3", "N6",
    ], [
        "p0", "P6", "P9", "P12", "P24",
    ]
]


export function calcScore(data: Core) {
    console.log(data)
    let sc = 0
    if (data.checks.e1) sc += 1
    if (data.checks.e3) sc += 3
    if (data.checks.e6) sc += 6

    if (data.checks.s3) sc += 3
    if (data.checks.s6) sc += 6
    if (data.checks.s8) sc += 8
    if (data.checks.s9) sc += 9
    if (data.checks.s12) sc += 12
    if (data.checks.s15) sc += 15

    if (data.checks.i1) sc += 1
    if (data.checks.i3) sc += 3
    if (data.checks.i3c) sc += 3
    if (data.checks.i9) sc += 9

    if (data.checks.g1) sc += 1
    if (data.checks.g3) sc += 3
    if (data.checks.g4) sc += 4
    if (data.checks.g5) sc += 5
    if (data.checks.g6) sc += 6

    if (data.checks.n3) sc += 3
    if (data.checks.n6) sc += 6

    if (data.checks.r6) sc += 6
    if (data.checks.r9) sc += 9
    if (data.checks.r12) sc += 12
    if (data.checks.r24) sc += 24

    data.values.desingr_sum = sc.toString()

    return sc
}


export function designrToTextList(data: Core) {
    const res: string[] = []
    jokuso_lists_simple.forEach(lists => {
        let r = ""
        lists.forEach(t => {
            let name = t
            if (name[0] == "p") name = "r" + name.slice(1)
            else if (name[0] == "P") name = "R" + name.slice(1)
            name = name.toLowerCase()
            if (data.checks[name]) {
                r = t
            }
        })
        res.push(r)
    })

    return res
}